<template>
  <text-subpage page-type="imprint" />
</template>

<script>
import Vue from 'vue'
import TextSubpage from '~brand-components/lufthansa/shared/text-subpage.vue'

export default Vue.extend({
  components: {
    TextSubpage,
  },
})
</script>
